import track from "../assets/track 1.jpg";
import flight from "../assets/flight1.jpg";
import ocean from "../assets/ship1.jpg";

export const coreServices = [
  {
    title: "ROAD FREIGHT",
    image: track,
    alt: "Cargo Power semi-truck on the highway",
    description:
      "Cargo Power Logistics offers reliable and efficient road freight services tailored for the domestic transportation of goods. Our experienced team utilizes a fleet of modern vehicles to ensure that your cargo reaches its destination safely and on time.",
  },
  {
    title: "AIR FREIGHT",
    image: flight,
    alt: "Cargo airplane ascending into the sky",
    description:
      "With Cargo Power Logistics, experience fast and secure air freight services that cater to your global shipping needs. Our strategic partnerships with reputable airlines and a robust network of carriers allow us to offer competitive rates without compromising service quality.",
  },
  {
    title: "OCEAN FREIGHT",
    image: ocean,
    alt: "Container ship navigating deep blue ocean waters",
    description:
      "Cargo Power Logistics specializes in comprehensive ocean freight services designed to meet your international shipping requirements. We efficiently handle full container loads (FCL) and less than container loads (LCL), ensuring that your goods are transported securely and cost-effectively.",
  },
];
